import {BASE_API_URL, BASE_URL} from '../../server/routes/config';

export const GET_POSTS = `${BASE_API_URL}/posts`;

export const serialize = obj => {
  let str = '';
  for (const key in obj) {
    if (str !== '') {
      str += '&';
    }
    str += key + '=' + encodeURIComponent(obj[key]);
  }
  return str;
};

export const generateFullUrl = (url: string, query) => {
  return `/${BASE_URL}${url}?${serialize(query)}`;
};
